$(document).ready(function() {
  $(".auth_provider.signup").click(function(e) {
    var service = $(this).attr("href").replace(/\/auth\//,'');
    mixpanel.track("Started signup w/service", {
      distinct_id: mixpanel.get_distinct_id(),
      type: service, 
    });
  });
});
